/* LOADING REDUX — THE BOOT SCREEN OF THE PANEL, components/MainLoading.js CLEARS IT */

const DEFAULT = true

const loading = (state = DEFAULT, action) => {

    switch (action.type) {

        case "SET_LOADING":
            return action.payload

        default:
            return state

    }
}

export default loading